import { Button, ButtonBase } from '@mui/material';
import { styled } from '@mui/system';
import color from 'styles/color';

export const HeaderButtonWrapper = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  height: 35,
  marginLeft: -12,
}));

export const DuplicateButton = styled(ButtonBase)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  padding: '0px 4px',
  border: '1px solid #dedede',
  borderRadius: 4,
  fontSize: '10px',
  background: theme.palette.grey[300],
  color: theme.palette.common.black,
}));

export const RestButton = styled(ButtonBase)<{ isRest: boolean }>(
  ({ theme }) => ({
    position: 'absolute',
    right: 0,
    padding: '0px 4px',
    border: '1px solid #dedede',
    borderRadius: 4,
    fontSize: '10px',
    color: theme.palette.error.contrastText,
  }),
);

export const ChipWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px',
  width: '200px',
  padding: '8px 0px',
  paddingBottom: '0px',
}));

export const CopyButton = styled('button')`
  background-color: ${color.blue01};
  position: absolute;
  bottom: 2px;
  outline: none;
  border: none;
  color: ${color.blue06};
  right: 4px;
  padding: 4px;
  border-radius: 4px;
  :active {
    background-color: ${color.blue03};
  }
  :nth-child(2) {
    right: 40px;
  }
`;
